import React from 'react'

import { PropertyDefinition } from 'api/propertyDefinitions/types'

export const PropertyDefinitionContext = React.createContext<
  PropertyDefinition[]
>([])
